let config = {
    featureManager: null,
};
/**
 * Configure UI Manager
 */
export function configureEditTools(editToolsConfig) {
    config = editToolsConfig;
}
export const getFeatureManager = () => config.featureManager;
//# sourceMappingURL=configureEditTools.js.map